function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.23776e-08 4.80058C-0.000224928 3.51206 0.524151 2.27755 1.45513 1.37482C2.38612 0.472097 3.64552 -0.0230327 4.95 0.000823829C6.49559 -0.00728242 7.9704 1.2318 9 2.37025C10.0296 1.2318 11.5044 -0.00728242 13.05 0.000823829C14.3545 -0.0230327 15.6139 0.472097 16.5449 1.37482C17.4758 2.27755 18.0002 3.51206 18 4.80058C18 9.56122 12.2589 13.1557 9 16C5.7483 13.1317 7.23776e-08 9.56477 7.23776e-08 4.80058Z",
  fill: "white"
});

function SvgFavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFavoriteIcon;